/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyCodeRequest
 */
export interface VerifyCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof VerifyCodeRequest
     */
    code: string;
}

/**
 * Check if a given object implements the VerifyCodeRequest interface.
 */
export function instanceOfVerifyCodeRequest(value: object): value is VerifyCodeRequest {
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function VerifyCodeRequestFromJSON(json: any): VerifyCodeRequest {
    return VerifyCodeRequestFromJSONTyped(json, false);
}

export function VerifyCodeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyCodeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
    };
}

export function VerifyCodeRequestToJSON(value?: VerifyCodeRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'code': value['code'],
    };
}

